<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-model="isShow" v-if="notification != null" :width=700>
        <v-card class="mt-3 pa-1">
            <Title title="通知">
                <v-spacer />
                <TitleButton
                    color="primary"
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isShow=false" />
            </Title>
            <v-card-text class="pa-0" >
                <!-- 受信通知表示 -->
                <div v-if="isReceivedNotification">
                    <v-container fluid class="pa-1">
                        <v-row dense>
                            <v-col>
                                <table style="width:100%">
                                    <tr>
                                        <td rowspan="2">
                                            <v-avatar rounded>
                                                <v-img v-if="notification.sender.userUID == ''" src="@/assets/icon-72x72_no_bg.png"/>
                                                <v-img v-else-if="notification.sender.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                <v-img v-else-if="notification.sender.avaterURL != null" :src="notification.sender.avaterURL"/>
                                            </v-avatar>
                                        </td>
                                        <td style="width:100%" colspan="2">
                                            <span v-if="!$vuetify.breakpoint.xs" class="headline font-weight-bold" style="vertical-align:middle">
                                                <v-icon>{{icon(notification.body)}}</v-icon>
                                                {{notification.body.content.title}}
                                            </span>
                                            <span v-else class="body-1 font-weight-bold" style="vertical-align:middle">
                                                <v-icon>{{icon(notification.body)}}</v-icon>
                                                {{title(notification.body.content.title, 20)}}
                                            </span>
                                            <v-divider />
                                        </td>
                                    </tr>
                                    <tr v-if="!$vuetify.breakpoint.xs">
                                        <td>
                                            <strong>
                                                差出人:
                                                <span v-if="notification.sender.userUID != ''">{{notification.sender.userName}}</span>    
                                                <span v-else>【圃場管理システム】</span>    
                                            </strong>
                                        </td>
                                        <td style="text-align:right">
                                            <span class="caption">{{notification.body.dateTime}}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="$vuetify.breakpoint.xs">
                                        <td>
                                            <strong>
                                                差出人:
                                                <span v-if="notification.sender.userUID != ''">{{notification.sender.userName}}</span>    
                                                <span v-else>【圃場管理システム】</span>    
                                            </strong>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="$vuetify.breakpoint.xs">
                                        <td></td>
                                        <td><span class="caption">{{notification.body.dateTime}}</span></td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-divider />
                        <v-row dense>
                            <v-col>
                                <v-card outlined flat class="ma-1">
                                    <v-card-text>
                                        <div v-html="notification.body.content.message.replace(/\r?\n/g, '<br>')" :class="'pa-1 '+($vuetify.breakpoint.xs ? 'caption' : 'body-1')" />
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-if="attachedFiles.length > 0" dense>
                            <v-col>
                                <v-icon>mdi-attachment</v-icon>
                                <v-chip v-for="file in attachedFiles" :key="file.url" label class="ma-1" color="primary" @click="onClickAttachedFile(file)">
                                    {{file.filename}}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-row v-if="images.length > 0">
                            <Images v-model="images" :enableImport="false" :enableDelete="false" />
                        </v-row>
                        <!-- <v-divider /> -->
                        <v-row dense>
                            <v-col>
                                <v-toolbar dense flat v-if="notification.body.content.type == 13 || notification.body.content.type == 90" >
                                    <v-spacer />
                                    <v-btn depressed color="primary" @click="onClickReply"><v-icon>mdi-reply</v-icon>返信</v-btn>
                                </v-toolbar>
                                <v-toolbar dense flat v-if="notification.body.content.type == 10 && notification.body.data.answeredDateTime == ''">
                                    <v-spacer />
                                    <v-btn depressed color="primary" @click="onClickRequestGroupJoinAnswer(1)" class="mr-1"><v-icon>mdi-handshake-outline</v-icon>参加する</v-btn>
                                    <v-btn depressed color="primary" @click="onClickRequestGroupJoinAnswer(2)"><v-icon>mdi-cancel</v-icon>参加しない</v-btn>
                                </v-toolbar>
                                <v-toolbar dense flat v-else-if="notification.body.content.type == 20 || notification.body.content.type == 30">
                                    <v-spacer />
                                    <v-btn depressed color="primary" @click="onClickViewWork()">
                                        <v-icon>mdi-arrow-right</v-icon>
                                        表示
                                    </v-btn>
                                </v-toolbar>
                            </v-col>
                        </v-row>
                        <v-divider v-if="histories != null && histories.length > 0" class="mb-2" />
                        <v-row v-if="histories != null && histories.length > 0">
                            <v-col class="pa-0">
                                <div v-for="(history, index) in histories" :key="index">
                                    <div class="d-flex flex-no-wrap">
                                        <v-avatar class="ml-2" rounded>
                                            <v-img v-if="history.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                            <v-img v-if="history.userInfo.avaterURL != null" :src="history.userInfo.avaterURL"/>
                                        </v-avatar>
                                        <div class="balloon2-left" style="margin-top:0px; margin-right:10px; width:100%">
                                            <v-card-text class="pa-1">
                                                <div class="subtitle-2 font-weight-bold mb-1">{{history.userInfo.userName}}</div>
                                                <div class="subtitle-2 font-weight-bold mb-1">{{history.body.content.title}}</div>
                                                <div class="body-2 mb-1" v-html="history.body.content.message.replace(/\r?\n/g, '<br>')" />
                                                <div class="caption text-right">{{history.body.dateTime}}</div>
                                            </v-card-text>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
                <!-- 送信通知表示 -->
                <div v-else>
                    <v-container fluid class="pa-1">
                        <v-row dense>
                            <v-col>
                                <table style="width:100%">
                                    <tr>
                                        <td style="width:100%" colspan="2">
                                            <!-- <v-chip label color="grey lighten-3" small class="mr-2">件名</v-chip> -->
                                            <span v-if="!$vuetify.breakpoint.xs" class="headline font-weight-bold" style="vertical-align:middle">{{notification.body.notification.content.title}}</span>
                                            <span v-else class="caption font-weight-bold" style="vertical-align:middle">{{notification.body.notification.content.title}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <table>
                                                <tr v-if="['all','group_all','group','belong_group_all','belong_group'].findIndex((v)=>v == notification.body.type) >= 0">
                                                    <td>
                                                        <v-chip-group>
                                                            <v-chip small v-for="(receiver, index) in receivers" :key="index" color="cyan lighten-4" label>
                                                                {{receiver.groupName}}
                                                            </v-chip>
                                                        </v-chip-group>
                                                    </td>
                                                </tr>
                                                <tr v-if="notification.body.type=='group_member' || notification.body.type=='belong_group_member' || notification.body.type=='reply' || notification.body.type=='custom'">
                                                    <v-chip-group v-if="users.length > 1">
                                                        <v-chip small v-for="(user, index) in users" :key="index" color="cyan lighten-4" label>
                                                            {{user.userName}}
                                                        </v-chip>
                                                    </v-chip-group>
                                                    <table v-else>
                                                        <tr>
                                                            <td>
                                                                <v-avatar rounded size="30">
                                                                    <v-img v-if="users[0].avaterURL == null || users[0].avaterURL == ''" src="@/assets/no_avater_image.png"/>
                                                                    <v-img v-else :src="users[0].avaterURL"/>
                                                                </v-avatar>
                                                            </td>
                                                            <td>
                                                                {{users[0].userName}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </tr>
                                            </table>
                                        </td>
                                        <td style="text-align:right" v-if="!$vuetify.breakpoint.xs">
                                            <span class="caption">{{notification.body.notification.dateTime}}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="$vuetify.breakpoint.xs">
                                        <td>
                                            <span class="caption">{{notification.body.notification.dateTime}}</span>
                                        </td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-divider />
                        <v-row dense>
                            <v-col>
                                <v-card outlined flat class="ma-1">
                                    <v-card-text>
                                        <div v-html="notification.body.notification.content.message.replace(/\r?\n/g, '<br>')"  :class="'pa-1 '+($vuetify.breakpoint.xs ? 'caption' : 'body-1')"  />
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-if="attachedFiles.length > 0" dense>
                            <v-col>
                                <v-icon>mdi-attachment</v-icon>
                                <v-chip v-for="file in attachedFiles" :key="file.url" label class="ma-1" color="primary" @click="onClickAttachedFile(file)">
                                    {{file.filename}}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-row v-if="images.length > 0">
                            <Images v-model="images" :enableImport="false" :enableDelete="false" />
                        </v-row>
                        <v-divider v-if="histories != null && histories.length > 0" class="mb-2" />
                        <v-row v-if="histories != null && histories.length > 0">
                            <v-col class="pa-0">
                                <div v-for="(history, index) in histories" :key="index">
                                    <div class="d-flex flex-no-wrap">
                                        <v-avatar class="ml-2" rounded>
                                            <v-img v-if="history.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                            <v-img v-if="history.userInfo.avaterURL != null" :src="history.userInfo.avaterURL"/>
                                        </v-avatar>
                                        <div class="balloon2-left" style="margin-top:0px; margin-right:10px; width:100%">
                                            <v-card-text class="pa-1">
                                                <div class="subtitle-2 font-weight-bold mb-1">{{history.userInfo.userName}}</div>
                                                <div class="subtitle-2 font-weight-bold mb-1">{{history.body.content.title}}</div>
                                                <div class="body-2 mb-1" v-html="history.body.content.message.replace(/\r?\n/g, '<br>')" />
                                                <div class="caption text-right">{{history.body.dateTime}}</div>
                                            </v-card-text>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="message.isView" :timeout=2000 :color="message.color">{{message.message}}</v-snackbar>
        <Confirm ref="confirm" />
        <Observater ref="observater" readOnly />
        <HarvestObservater ref="harvestObservater" readOnly />
        <NotificationCreator ref="notificationCreator" />
        <WorkRecorder
            ref="workRecorder" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Confirm from '@/components/tools/ConfirmDialog';
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Observater from '@/components/seedling/items/Observater';
    import HarvestObservater from '@/components/seedling/items/HarvestObservater';
    import NotificationCreator from '@/components/notification/items/NotificationCreator';
    import WorkRecorder from '@/components/place/RecorderPlaceWork'
    import Images from '@/components/tools/Images';

    export default {
        components: {
            Confirm,
            Title,
            TitleButton,
            Observater,
            HarvestObservater,
            NotificationCreator,
            WorkRecorder,
            Images
        },
        data: function() {
            return {
                isShow: false,
                isReceivedNotification: true,
                notification: null,
                message: {
                    isView: false,
                    message: "",
                    color: "primary"
                },
                receivers: [],
                selectedReceiver: null,
                users: [],
                selectedUser: null,
                images: [],
                attachedFiles: [],
                /** 履歴 */
                histories: null,
            }
        },
        computed: {
            userUID: function() {
                return this.$store.getters["userUID"]
            },
            userData: function() {
                return this.$store.getters["userData"]
            },
        },
        methods: {
            /**
             * 添付ファイルクリック時
             */
            onClickAttachedFile: function (file) {
                console.log(file)
                const link = document.createElement("a")
                link.href = file.url
                link.download = file.filename
                link.click()
            },
            /**
             * 表示する件名を指定された長さで切ってから返す
             */
            title: function (title, length) {
                return title.length > length ? title.substr(0, length)+"..." : title
            },
            /**
             * 指定された通知から件名に表示するアイコンを返す
             */
            icon: function (notification) {
                switch (notification.content.type) {
                    case 1:
                        return "mdi-information"
                    case 10:
                    case 11:
                    case 12:
                        return "mdi-share-variant"
                    case 13:
                        switch (notification.data.type) {
                            case 0:
                                return "mdi-information"
                            case 1:
                                return "mdi-alert"
                        }
                        break
                    case 20:
                        return "mdi-comment-account"
                    case 30:
                        return "mdi-file-document-edit-outline"
                    case 90:
                        return "mdi-message-alert"
                }
            },
            /**
             * このダイアログを表示
             */
            show: function(notification, isReceivedNotification){

                console.log("NotificationViewer", notification)

                if (isReceivedNotification == null || isReceivedNotification == undefined) {
                    isReceivedNotification = true
                }

                this.isReceivedNotification = isReceivedNotification

                const currentDateTime = this.df_currentDateTime()

                this.isShow = true
                this.notification = notification
                this.images = []

                this.histories = []
                var historiesSource = isReceivedNotification ? notification.body : notification.body.notification

                if (historiesSource.histories != null && historiesSource.histories.length > 0) {
                    for (var i=historiesSource.histories.length-1; i>=0; i--) {
                        const history = historiesSource.histories[i]
                        const historyData = {
                            body: history,
                            userInfo: {
                                userName: "",
                                avaterURL: ""
                            }
                        }
                        // console.log(historyData)
                        this.mi_userData(historyData.body.sender.userUID, historyData.userInfo)
                        this.histories.push(historyData)
                    }
                }
                // console.log(this.histories)

                if (isReceivedNotification) {
                    /**
                     * 受信通知の表示の時
                     */
                    this.createAttachedDatas(notification.body.attachedFiles)

                    /**
                     * 未開封なら開封日時を通知にセット
                     */
                    if (notification.body.openedDateTime != '') {
                        return
                    }
                    
                    switch (notification.body.content.type) {
                        case 1:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 20:
                        case 30:
                        case 90:
                            this.$store.commit("openedNotification", {
                                openedDateTime: currentDateTime,
                                notification: notification.body
                            })
                            break
                    }
                } else {
                    /** 送信通知 */
                    this.createAttachedDatas(notification.body.notification.attachedFiles)

                    switch (notification.body.type) {
                        case "all":
                        case "group_all":
                        case "group":
                        case "belong_group_all":
                        case "belong_group":
                            this.receivers = notification.receivers
                            this.selectedReceiver = this.receivers[0]
                            break
                        case "group_member":
                        case "belong_group_member":
                            this.users = notification.receivers
                            this.selectedUser = this.users[0]
                            break
                        case "custom":
                            this.users = notification.receivers[0].users
                            this.selectedUser = this.users[0]
                            break
                        case "reply":
                            this.users = []
                            this.users.push(notification.receivers[0])
                            this.selectedUser = this.users[0]
                            break
                    }
                }
                // console.log("notification viewer show completed!")
            },
            /**
             * 指定された通知内の添付ファイルの値から、表示する画像及びファイルの配列を作成
             */
            createAttachedDatas: function (attachedFiles) {
                this.images = []
                this.attachedFiles = []
                if (attachedFiles == null || attachedFiles.length == 0) {
                    return
                }
                const self = this
                const imageTypes = ["png", "jpg", "jpeg", "gif", "bmp"]
                var imageIndex = 0
                attachedFiles.forEach(function(file){
                    console.log(file)
                    if (imageTypes.findIndex((v)=>v == file.type) >= 0) {
                        const imageData = {
                            no: imageIndex+1,
                            state: 1,
                            image: "",
                            url: file.url,
                            capturedDate: "",   // 通知の時は、この情報無し
                            comments: []
                        }
                        // console.log("createImages", imageData)
                        self.images.push(imageData)
                        imageIndex++
                    } else {
                        // console.log("unknown file type", file)
                        const fileData = {
                            url: file.url,
                            type: file.type,
                            filename: file.filename
                        }
                        self.attachedFiles.push(fileData)
                    }
                })
            },
            /**
             * 返信ボタン押下時
             */
            onClickReply: function () {
                // console.log("onClickReply", this.notification)
                if (this.isReceivedNotification) {
                    this.$refs.notificationCreator.show(
                        {
                            type: "reply",
                            notification: this.notification,
                        }
                    )
                } else {
                    // const paramNotification = {
                    //     body: this.notification.body.notification,
                    //     sender: {
                    //         userName: "",
                    //         avaterURL: ""
                    //     }
                    // }
                    // this.mi_userData(paramNotification.body.sender.userUID, paramNotification.sender)
                    // this.$refs.notificationCreator.show(
                    //     {
                    //         type: "reply",
                    //         notification: paramNotification
                    //     }
                    // )
                }
            },
            /**
             * 作業記録表示ボタン押下時
             */
            onClickViewWork: function () {
                // console.log(this.notification)
                // switch (this.notification.body.data.target) {
                //     case 1:     // 苗の観察記録へのコメント
                //         this.$refs.observater.showFromNotification(this.notification.body.data.targetKey)
                //         break;
                //     case 2:     // 収穫物の観察記録へのコメント
                //         this.$refs.harvestObservater.showFromNotification(this.notification.body.data.targetKey)
                //         break;
                // }
                // console.log("NotificationViewer", "onClickViewWork")
                switch (this.notification.body.data.target) {
                    case 3:     // 圃場の作業記録へのコメント
                        this.showPlaceWorkRecord()
                        break;
                }
            },
            /**
             * グループ参加依頼への返信ボタン押下時
             */
            onClickRequestGroupJoinAnswer: function (result) {
                const self = this
                var message = ""
                switch (result) {
                    case 1: 
                        message = "参加する"
                        break;
                    case 2: 
                        message = "参加しない"
                        break;
                }
                this.$refs.confirm.show({
                    title: "グループ参加依頼への返信",
                    message: "<strong>" + this.notification.sender.userName + "</strong>さんからのグループ参加依頼に<br/>["+message+"] を返信しますか？",
                    width: 400,
                    buttonYes: "返信する",
                    buttonNo: "返信しない",
                    listenerYes: function () {
                        self.answserRequestGroupJoin(result)
                        return true
                    },
                })
            },
            /**
             * 作業記録画面を表示
             */
            showPlaceWorkRecord: async function () {

                const self = this

                // 作業記録表示用のデータを取得
                this.$store.commit("processing", {start:true, message:"作業記録の準備をしています。 お待ち下さい…。"})

                try {
                    // this.workRecorderProperties = {
                    //     place: null,
                    //     workTypes: [],
                    //     composts: null,
                    //     fertilizeries: null,
                    //     pesticides: null
                    // }

                    const placeData = this.$store.getters["managementItems/loggedInUserPlaceData"]
                    const targetKey = this.notification.body.data.targetKey

                    const place = placeData.places.find((v)=>v.body.placeID == targetKey.placeID)
                    const workTypes = []
                    
                    for (var i=0; i<place.workTypes.length; i++) {
                        workTypes.push(place.workTypes[i])
                    }
                    for (var i=0; i<place.userWorkTypes.length; i++) {
                        workTypes.push(place.userWorkTypes[i])
                    }

                    const targetWork = place.works.find((v)=>v.workID == targetKey.workID)
                    if (targetWork == null) {
                        this.$refs.confirm.show({
                            title: "作業記録の表示",
                            message: "該当する作業が見つかりませんでした。<br/>既に削除されている作業の可能性があります。",
                            width: 400,
                            buttonYes: "戻る",
                            buttonNo: "",
                        })
                        return
                    }

                    const record = targetWork.records.find((v)=>v.dateTime == targetKey.recordDateTime)

                    if (record == null) {
                        this.$refs.confirm.show({
                            title: "作業記録の表示",
                            message: "作業記録が見つかりませんでした。<br/>既に削除されている作業記録の可能性があります。",
                            width: 400,
                            buttonYes: "戻る",
                            buttonNo: "",
                        })
                        return
                    }
                    
                    this.$refs.workRecorder.show(place, workTypes, targetWork, record)

                } catch (error) {
                        console.log("NotificationViewer","showPlaceWorkRecord","failed!!",error)
                } finally {
                    this.$store.commit("processing", {start:false})
                }
            },
            /**
             * グループ参加依頼に対しての応答処理
             * @param result 1:参加,2:不参加
             */
            answserRequestGroupJoin: function (result) {
                try{
                    const self = this
                    const currentDateTime = this.df_currentDateTime()

                    var message = ""
                    switch (result) {
                        case 1: 
                            message = "グループへ参加します。"
                            break;
                        case 2: 
                            message = "グループへの参加は辞退します。"
                            break;
                    }
                    var notificator = function (result) {
                        self.$store.commit("sendNotification", {
                            to: {                            
                                userUID: self.notification.body.sender.userUID,
                            },
                            sender: {
                                userUID: self.userUID,
                                userData: self.userData
                            },
                            content: {
                                type: 11,
                                title: "グループ参加依頼返信",
                                message: message
                            },
                            data: {
                                groupNo: self.notification.body.data.groupNo,
                                groupName: self.notification.body.data.groupName,
                                result: result
                            },
                            success: function () {
                                self.$store.commit("notification", {message:"グループへの参加依頼への返信を通知しました。"})
                                // 通知の応答日時を更新して終了
                                db.collection("users").doc(self.userUID)
                                .collection("notifications").doc(self.notification.body.notificationID).update(
                                    {
                                        "data.answeredDateTime": currentDateTime
                                    }).then(function(){
                                        self.notification.body.data.answeredDateTime = currentDateTime
                                        self.isShow = false
                                    }).catch(function(error){
                                        cnosole.log(error)
                                    })
                            },
                            failed: function (error) {
                                console.log(error)
                                self.$store.commit("notification", {message:"グループへの参加依頼への返信の通知に失敗しました。", isError:true})
                            }
                        })
                    }

                    var belongGroupRegister = function () {
                        // =============================
                        // 所属グループを登録
                        const belongGroup = {
                            version: "2.0.0",
                            ownerUserUID: self.notification.body.sender.userUID,
                            groupNo: self.notification.body.data.groupNo,
                            registeredDateTime: currentDateTime,
                            updatedDateTime: ""
                        }
                        db.collection("users").doc(self.userUID).collection("belong_groups").doc(self.notification.body.sender.userUID + "-" + self.notification.body.data.groupNo).
                        set(belongGroup).then(function(){
                            // =============================
                            // 依頼したユーザーに結果を通知
                            notificator(result)

                            // 管理データに追加
                            self.$store.commit("managementItems/addBelongGroup", belongGroup)

                        }).catch(function(error){
                            console.log(error)
                            self.$store.commit("notification", {message:"所属登録に失敗しました。", isError:true})
                        })
                    }

                    // =============================
                    // 依頼したユーザーのグループ配下のユーザー情報の状態を更新
                    var docUser = db.collection("users").doc(this.notification.body.sender.userUID)
                    var docGroup = docUser.collection("groups").doc(""+this.notification.body.data.groupNo)
                    var docGroupUser = docGroup.collection("users").doc(this.userUID)
                    var state = null
                    switch (result) {
                        case 1: 
                            state = 1
                            break;
                        case 2:
                            state = 2
                            break;
                    }
                    docGroupUser.update(
                        {
                            "state": state,
                            "updatedDateTime": currentDateTime
                        }).
                    then(function(){
                        switch (result) {
                            case 1:
                                // 所属グループ登録                        
                                belongGroupRegister()
                                break;
                            case 2:
                                // 通知送信
                                notificator(result)
                                break;
                        }
                    }).catch(function(error){
                        console.log(error)
                    })
                } catch (error) {
                    console.log(error)
                }
            },
        }        
    }
</script>

<style scoped>
    .balloon2-left {
        position: relative;
        display: inline-block;
        margin: 1.5em 0 1.5em 15px;
        padding: 0px 10px;
        min-width: 120px;
        max-width: 100%;
        color: #555;
        font-size: 16px;
        background: #FFF;
        border: solid 3px #555;
        border-radius: 8px;
        box-sizing: border-box;
    }

    .balloon2-left:before {
        content: "";
        position: absolute;
        top: 24px;
        left: -22px;
        margin-top: -12px;
        border: 12px solid transparent;
        border-right: 12px solid #FFF;
        z-index: 2;
    }

    .balloon2-left:after {
        content: "";
        position: absolute;
        top: 24px;
        left: -28px;
        margin-top: -14px;
        border: 14px solid transparent;
        border-right: 14px solid #555;
        z-index: 1;
    }

    .balloon2-left p {
        margin: 0;
        padding: 0;
    }
</style>
